import { all, takeLatest, put, fork, call } from 'redux-saga/effects';
import actions from './actions';
import { toastMessage } from '../../constants/Models';
import HistoryTreePlanningService from '../../services/historyTreePlanning';
import treeSiteService from '../../services/treeManagement';

//#region CRUD
export function* getHistoryTreePlanning() {
	yield takeLatest(actions.GET_HISTORY_TREE_PLANNING, function* ({ body }) {
		try {					
			const response = yield call(HistoryTreePlanningService.getHistoryTreePlanning, body);	
			if (response?.data) {
				yield put({
					type: actions.GET_HISTORY_TREE_PLANNING_SUCCESS,
					payload: response.data,
				});
			}
		} catch (e) {}
	});
}

export function* createHistoryTreePlanning() {
	yield takeLatest(actions.CREATE_GREEN_NEWS, function* ({ body, cbSuccess, cbError }) {
		try {
			const response = yield call(HistoryTreePlanningService.createHistoryTreePlanning, body);
			if (response?.data) {
				cbSuccess(toastMessage.addSuccess);
			}
		} catch (e) {
			cbError(toastMessage.addError);
		}
	});
}

export function* createTreeHistory() {
	yield takeLatest(actions.CREATE_TREE_HISTORY, function* ({ body, cbSuccess, cbError }) {
		try {
			
			const response = yield call(treeSiteService.createTreeHistory, body);
			if (response?.data) {
				yield put({
					type: actions.CREATE_TREE_HISTORY_SUCCESS,
					payload: response.data,
				});
				cbSuccess(toastMessage.addSuccess);
			}
		} catch (e) {
			yield put({
				type: actions.CREATE_TREE_HISTORY_ERROR,
				payload: e.message,
			});
			cbError(toastMessage.addError);
		}
	});
}

export function* updateHistoryTreePlanning() {
	yield takeLatest(actions.UPDATE_HISTORY_TREE_PLANNING, function* ({ id, body, cbSuccess, cbError }) {
		try {
			const response = yield call(HistoryTreePlanningService.updateHistoryTreePlanning, id, body);
			if (response?.data) {
				cbSuccess(toastMessage.updateSuccess);
			}
		} catch (e) {
			cbError(toastMessage.updateError);
		}
	});
}

export function* deleteHistoryTreePlanning() {
	yield takeLatest(actions.DELETE_GREEN_NEWS, function* ({ id, cbSuccess, cbError }) {
		try {
			const response = yield call(HistoryTreePlanningService.deleteHistoryTreePlanning, id);
			if (response?.data) {
				cbSuccess(toastMessage.deleteSuccess);
			}
		} catch (e) {
			cbError(toastMessage.deleteError);
		}
	});
}

export function* exportHistoryTreePlanning() {
	yield takeLatest(actions.EXPORT_GREEN_NEWS, function* ({ body, cbError }) {
		try {
			const response = yield call(HistoryTreePlanningService.getHistoryTreePlanning, body);
			if (response?.data) {
				yield put({
					type: actions.EXPORT_GREEN_NEWS_SUCCESS,
					payload: response.data,
				});
			}
		} catch (e) {
			cbError(toastMessage.exportError);
		}
	});
}

export default function* rootSaga() {
	//yield all([fork(getHistoryTreePlanning), fork(createHistoryTreePlanning), fork(deleteHistoryTreePlanning), fork(updateHistoryTreePlanning), fork(exportHistoryTreePlanning)]);
	yield all([fork(getHistoryTreePlanning), fork(updateHistoryTreePlanning), fork(createTreeHistory)]);
}
